// Cart checkout gate.
//
// Mirrors the rule in snippets/cart-checkout-gate.liquid: a cart without a
// subscription line item cannot check out below the one-time order minimum
// (theme settings > Cart > Checkout rules).
//
// The checkout buttons sit outside the sections a cart update re-renders, so
// the gate is re-applied on every published cartUpdate. Loaded on every page
// because the popup notification (cart_type: notification) also carries a
// checkout button, and assets/cart.js is not loaded outside the cart page then.

function isCheckoutBlocked(cart, minimum) {
  if (!cart || !Array.isArray(cart.items) || cart.item_count === 0) return false;

  const hasSubscription = cart.items.some((item) => item.selling_plan_allocation);
  return !hasSubscription && cart.total_price < minimum;
}

function applyCheckoutGate(cart) {
  const minimum = window.cartGate && window.cartGate.minimumOneTimeOrder;
  if (!minimum) return;

  const blocked = isCheckoutBlocked(cart, minimum);
  const empty = cart.item_count === 0;

  document.querySelectorAll('[data-cart-checkout]').forEach((button) => {
    button.disabled = empty || blocked;
  });

  document.querySelectorAll('[data-cart-minimum-notice]').forEach((notice) => {
    notice.classList.toggle('hidden', !blocked);
  });

  document.querySelectorAll('[data-cart-express-checkout]').forEach((express) => {
    express.classList.toggle('hidden', blocked);
  });
}

function updateCheckoutGate(cart) {
  if (!window.cartGate || !window.cartGate.minimumOneTimeOrder) return;

  // /cart/change.js responses carry the full cart, /cart/add.js does not
  // guarantee it, so fall back to /cart.js when the payload is unusable.
  if (cart && Array.isArray(cart.items) && typeof cart.total_price === 'number') {
    applyCheckoutGate(cart);
    return;
  }

  fetch('/cart.js')
    .then((response) => response.json())
    .then(applyCheckoutGate)
    .catch((error) => console.error(error));
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => updateCheckoutGate(event.cartData));
